module.exports = __webpack_public_path__ + "img/2-3.7baf91f8.png";